export const presentError = error => {
  if (!error || error === '') return 'Something went wrong, please contact support.';
  if (error === 'invalid_credentials') return 'Invalid credentials';
  return error;
};

export const shouldSilenceError = error => {
  if (error === 'Previous payment information not found.' || error === 'Previous payment information is invalid.') {
    return true;
  }
  if (error.includes('Unauthenticated')) {
    return true;
  }
  return false;
};
